import { createSelector } from '@ngrx/store';
import { AppState } from '../../app.state';
import { OMSOrder, Side } from '@easy-lib/modules/order';
import { AggregateState, OrderModelType } from '@easy-lib/constants';

const getPortfolioState = (state: AppState) => state.portfolioState;
const getOmsState = (state: AppState) => state.omsState;

// export const getTodayActivityShouldCallIsins = createSelector(
// 	getPortfolioState,
// 	getOmsState,
// 	(portfolioState, omsState) => {
// 		const oMSOrders = Object.values(omsState.entities)
// 			.filter(order => order.orderModelType === OrderModelType.oms)
// 			.map(order => new OMSOrder({ ...order }));
// 		const oMSOrdersIsins = Array.from(new Set(oMSOrders.map(value => value.symbolIsin)));
// 		const portfolioTodayActivityItems = portfolioState.portfolioItems
// 			.filter(value => oMSOrdersIsins.includes(value.symbolIsin))
// 			.map(x => x.symbolIsin);
// 		return ['IRO1SIPA0001']; //oMSOrdersIsins.filter(value => !portfolioTodayActivityItems.includes(value));
// 	}
// );
export const getTodayActivityData = createSelector(getPortfolioState, getOmsState, (portfolioState, omsState) => {
	const oMSOrders = Object.values(omsState.entities)
		.filter(order => order.orderModelType === OrderModelType.oms)
		.map(order => new OMSOrder({ ...order }));
	const oMSOrdersIsins = Array.from(new Set(oMSOrders.map(value => value.symbolIsin)));

	const aggregates: {
		symbolIsin: string;
		symbolName: string;
		stateCode: string;
		asset: number;
		meanBuyOrderPrice: number;
		meanBuyTradePrice: number;
		meanSellOrderPrice: number;
		meanSellTradePrice: number;
		openBuyQuantity: number;
		openSellQuantity: number;
		tradedBuyQuantity: number;
		tradedSellQuantity: number;
	}[] = [];

	oMSOrdersIsins.forEach(oMSOrdersIsin => {
		const portfolioItem = portfolioState.entities[oMSOrdersIsin];
		const oMSOrder = oMSOrders.find(item => item.symbolIsin === oMSOrdersIsin);
		const orderInfo = {
			symbolIsin: oMSOrder?.symbolIsin,
			symbolName: oMSOrder?.symbolName,
			asset: portfolioItem?.asset ?? 0,
			meanBuyOrderPrice: 0,
			meanSellOrderPrice: 0,
			meanBuyTradePrice: 0,
			meanSellTradePrice: 0,
			openBuyQuantity: 0,
			openSellQuantity: 0,
			tradedBuyQuantity: 0, //portfolioItem?.dailyBoughtVolume,
			tradedSellQuantity: 0, //portfolioItem?.dailySoldVolume,
			stateCode: portfolioItem?.stateCode ?? ''
		};

		orderInfo.tradedBuyQuantity = oMSOrders
			.filter(
				order =>
					order.symbolIsin === oMSOrder.symbolIsin &&
					order.side === Side.Buy &&
					order.AggregateState === AggregateState.Done
			)
			.map(order => order.quantity)
			.reduce((prev, current) => prev + current, 0);

		orderInfo.tradedSellQuantity = oMSOrders
			.filter(
				order =>
					order.symbolIsin === oMSOrder.symbolIsin &&
					order.side === Side.Sell &&
					order.AggregateState === AggregateState.Done
			)
			.map(order => order.quantity)
			.reduce((prev, current) => prev + current, 0);

		orderInfo.openBuyQuantity = oMSOrders
			.filter(order => order.symbolIsin === oMSOrder.symbolIsin && order.side === Side.Buy && order.isOpenOrder)
			.map(order => order.quantity)
			.reduce((prev, current) => prev + current, 0);

		orderInfo.meanBuyOrderPrice =
			oMSOrders
				.filter(
					order => order.symbolIsin === oMSOrder.symbolIsin && order.side === Side.Buy && order.isOpenOrder
				)
				.map(order => order.quantity * order.price)
				.reduce((prev, current) => prev + current, 0) / orderInfo.openBuyQuantity || 0;

		orderInfo.openSellQuantity = oMSOrders
			.filter(order => order.symbolIsin === oMSOrder.symbolIsin && order.side === Side.Sell && order.isOpenOrder)
			.map(order => order.quantity)
			.reduce((prev, current) => prev + current, 0);

		orderInfo.meanSellOrderPrice =
			oMSOrders
				.filter(
					order => order.symbolIsin === oMSOrder.symbolIsin && order.side === Side.Sell && order.isOpenOrder
				)
				.map(order => order.quantity * order.price)
				.reduce((prev, current) => prev + current, 0) / orderInfo.openSellQuantity || 0;

		orderInfo.meanBuyTradePrice =
			oMSOrders
				.filter(
					order =>
						order.symbolIsin === oMSOrder.symbolIsin &&
						order.side === Side.Buy &&
						order.AggregateState === AggregateState.Done
				)
				.map(order => order.quantity * order.price)
				.reduce((prev, current) => prev + current, 0) / orderInfo.tradedBuyQuantity || 0;

		orderInfo.meanSellTradePrice =
			oMSOrders
				.filter(
					order =>
						order.symbolIsin === oMSOrder.symbolIsin &&
						order.side === Side.Sell &&
						order.AggregateState === AggregateState.Done
				)
				.map(order => order.quantity * order.price)
				.reduce((prev, current) => prev + current, 0) / orderInfo.tradedSellQuantity || 0;

		aggregates.push({ ...orderInfo });
	});

	return aggregates;
});
